export * from './spinner.service';
export * from './spinner.service.interface';
